import { ReactNode } from 'react';
import { useAuth } from '@app/AuthHook';
import { Loader } from '@igo/ui';
import { Navigate } from 'react-router-dom';
import styles from './styles.module.scss';
import { useAuthSelectors } from '@app/useAuthSelectors';
import { Role } from '@shared/enums';

type ProtectedRouteProps = {
    allowedRoles: Role[];
    fallbackRoute?: string;
    children: ReactNode;
};

export const ProtectedRoute = ({ allowedRoles, children, fallbackRoute = '/sign-in' }: ProtectedRouteProps) => {
    const { user, isUserDidFetch } = useAuth();

    const { hasRole } = useAuthSelectors();

    const isUserInRole = user && allowedRoles?.some((role) => hasRole(role));

    if (!isUserDidFetch) {
        return (
            <div className={styles.loader}>
                <Loader />
            </div>
        );
    }

    if (!user) {
        return <Navigate to={fallbackRoute} replace />;
    }

    if (!isUserInRole) {
        return <Navigate to="/" replace />;
    }

    return children;
};
